import { Button, ButtonKind } from "../../../../core/ui";

interface CoastMediaTabPaginationProps {
  goToPrevPage: () => void;
  goToNextPage: () => void;
  isLoadingNext: boolean;
  currentPage: number;
  totalPages: number;
}

export const CoastMediaTabPagination = ({
  currentPage,
  totalPages,
  goToPrevPage,
  goToNextPage,
  isLoadingNext,
}: CoastMediaTabPaginationProps) => (
  <div className="component-coast-media-tab-pagination">
    <Button kind={ButtonKind.CUSTOMIZED} click={goToPrevPage} disabled={currentPage <= 1}>
      &lt;
    </Button>
    <span>
      Page {currentPage} of {totalPages}
    </span>
    <Button kind={ButtonKind.CUSTOMIZED} click={goToNextPage} disabled={currentPage >= totalPages || isLoadingNext}>
      <>&gt;</>
    </Button>
  </div>
);
